import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export interface BreadcrumbItem { label: string; to?: string }

/** A real breadcrumb trail - the last item is never a link (it's the current page), matching standard convention. */
export function Breadcrumbs({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav className="breadcrumbs" aria-label="Breadcrumb">
      {items.map((item, i) => (
        <span key={i} className="breadcrumb-item">
          {item.to && i < items.length - 1 ? <Link to={item.to}>{item.label}</Link> : <span>{item.label}</span>}
          {i < items.length - 1 && <ChevronRight size={14} className="breadcrumb-separator" />}
        </span>
      ))}
    </nav>
  );
}
